import { useState, forwardRef, useImperativeHandle } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { CustomButton } from '../../CustomButton'
import { BsFloppyFill } from 'react-icons/bs'
import { XCircleFill } from 'react-bootstrap-icons'

import ReactInputMask from 'react-input-mask'
import apinode from '../../../services/apinode'
import { toast } from 'react-toastify'
import { CustomSpinner } from '../../CustomSpinner'
import { formatDate } from '../../../utils/formatDate'
import { apiCep } from '../../../services/apiCep'

import './styles.css'
import { useLocation } from 'react-router-dom'
import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'

export const FormClientes = forwardRef(
  ({ onSubmit, isRequestLoading, onBack, title }, ref) => {
    const initialState = {
      pes_cliente: 'S',
      pes_fornecedor: 'N',
      pes_transportadora: 'N',
      pes_fabricante: 'N',
      pes_funcionario: 'N',
      pes_parceiro: 'N',
      pes_prestador: 'N',
      cod_pessoa: '',
      pes_data_alteracao: '',
      tipo_cadastro: 'pes_cliente',
      cod_tipo_contribuinte: '1',
      pes_tipo: 'J',
      pes_consumidor_final: 'SIM',
      pes_razao: '',
      pes_fantasia: '',
      pes_data_fund_nasc: '',
      pes_cnpj_cpf: '',
      pes_insc_estadual: '',
      pes_insc_municipal: '',
      pes_cep: '',
      pes_ibge: '',
      pes_logradouro: '',
      pes_numero: '',
      pes_complemento: '',
      pes_bairro: '',
      pes_cidade: '',
      pes_uf: '',
      pes_telefone: '',
      pes_celular: '',
      pes_contato: '',
      pagamento: '',
      pes_email: '',
      pes_email_nfe: '',
    }

    const [customer, setCustomer] = useState(initialState)
    const [isCNPJSearchLoading, setIsCNPJSearchLoading] = useState(false)
    const [isCEPSearchLoading, setIsCEPSearchLoading] = useState(false)

    const { pathname } = useLocation()

    const tiposContribuinte = [
      {
        label: 'Contribuinte ICMS',
        value: '1',
      },
      {
        label: 'Contribuinte Isento',
        value: '2',
      },
      {
        label: 'Não Contribuinte',
        value: '9',
      },
      {
        label: 'Não Selecionado',
        value: '99',
      },
    ]

    const tiposPessoa = [
      {
        label: 'Física',
        value: 'F',
      },
      {
        label: 'Jurídica',
        value: 'J',
      },
    ]

    const isJuridical = customer.pes_tipo === 'J'
    const inEditPage = pathname !== '/clientes/novo' && !customer.cod_pessoa

    function handleChange(e) {
      const { name, value } = e.target

      setCustomer((prevState) => ({
        ...prevState,
        [name]: value,
      }))
    }

    async function getCompanyInfo(e) {
      const value = e.target.value.replace(/[^0-9]+/g, '')

      if (value.length === 14) {
        setIsCNPJSearchLoading(true)

        try {
          const { data } = await apinode.get(`/cnpj?cnpj=${value}`)

          setCustomer((prevState) => ({
            ...prevState,
            pes_razao: data.razao_social || '',
            pes_fantasia: data.nome_fantasia || '',
            pes_data_fund_nasc: data.data_inicio || '',
            pes_telefone: data.telefone1 || '',
            pes_logradouro: data.endereco.logradouro || '',
            pes_numero: data.endereco.numero || '',
            pes_bairro: data.endereco.bairro || '',
            pes_cidade: data.endereco.municipio || '',
            pes_uf: data.endereco.uf || '',
            pes_cep: data.endereco.cep || '',
            pes_complemento: data.endereco.complemento || '',
          }))

          try {
            const { data: dataCep } = await apiCep.get(
              `/${data.endereco.cep}/json/`,
            )

            setCustomer((prevState) => ({
              ...prevState,
              pes_ibge: dataCep.ibge,
            }))
          } catch {
            setCustomer((prevState) => ({
              ...prevState,
              pes_ibge: '',
            }))
          }
        } catch (err) {
          sendErrorApiMessage(
            err,
            'Erro ao buscar as informações, insira manualmente!',
          )
        } finally {
          setIsCNPJSearchLoading(false)
        }
      }
    }

    async function getCEPInfo(e) {
      const value = e.target.value.replace(/[^0-9]+/g, '')

      if (value.length === 8) {
        setIsCEPSearchLoading(true)

        try {
          const { data } = await apiCep.get(`/${value}/json/`)

          setCustomer((prevState) => ({
            ...prevState,
            pes_logradouro: data.logradouro || '',
            pes_bairro: data.bairro || '',
            pes_cidade: data.localidade || '',
            pes_uf: data.uf || '',
            pes_complemento: data.complemento || '',
            pes_ibge: data.ibge,
          }))
        } catch (error) {
          console.log(`Erro ao buscar as informações: ${error}`)

          return toast.error(
            'Erro ao buscar as informações, insira manualmente!',
          )
        } finally {
          setIsCEPSearchLoading(false)
        }
      }
    }

    useImperativeHandle(
      ref,
      () => ({
        getCustomer: () => {
          return customer
        },
        sendCustomer: (customer) => {
          setCustomer(customer)
        },
      }),
      [customer],
    )

    return (
      <>
        {inEditPage ? (
          <div
            style={{
              minHeight: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CustomSpinner />
          </div>
        ) : (
          <Form
            ref={ref}
            className="border p-4"
            onSubmit={onSubmit}
          >
            <h1>{title}</h1>

            <Row className="mb-3">
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Código</Form.Label>
                  <Form.Control
                    disabled
                    value={customer.cod_pessoa}
                  />
                </Form.Group>
              </Col>

              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Dt. Alterado</Form.Label>
                  <Form.Control
                    disabled
                    value={formatDate(customer.pes_data_alteracao) || ''}
                  />
                </Form.Group>
              </Col>

              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Tipo do Cadastro</Form.Label>

                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 10,
                    }}
                  >
                    <Form.Check
                      name="pes_cliente"
                      label="Cliente"
                      checked={customer.pes_cliente === 'S' ? true : false}
                      onChange={() => {
                        setCustomer((prevState) => ({
                          ...prevState,
                          pes_cliente:
                            prevState.pes_cliente === 'S' ? 'N' : 'S',
                        }))
                      }}
                    />

                    <Form.Check
                      name="pes_fornecedor"
                      label="Fornecedor"
                      checked={customer.pes_fornecedor === 'S' ? true : false}
                      onChange={() => {
                        setCustomer((prevState) => ({
                          ...prevState,
                          pes_fornecedor:
                            prevState.pes_fornecedor === 'S' ? 'N' : 'S',
                        }))
                      }}
                    />

                    <Form.Check
                      name="pes_transportadora"
                      label="Transportadora"
                      checked={
                        customer.pes_transportadora === 'S' ? true : false
                      }
                      onChange={() => {
                        setCustomer((prevState) => ({
                          ...prevState,
                          pes_transportadora:
                            prevState.pes_transportadora === 'S' ? 'N' : 'S',
                        }))
                      }}
                    />

                    <Form.Check
                      name="pes_fabricante"
                      label="Fabricante"
                      checked={customer.pes_fabricante === 'S' ? true : false}
                      onChange={() => {
                        setCustomer((prevState) => ({
                          ...prevState,
                          pes_fabricante:
                            prevState.pes_fabricante === 'S' ? 'N' : 'S',
                        }))
                      }}
                    />

                    <Form.Check
                      name="pes_funcionario"
                      label="Funcionário"
                      checked={customer.pes_funcionario === 'S' ? true : false}
                      onChange={() => {
                        setCustomer((prevState) => ({
                          ...prevState,
                          pes_funcionario:
                            prevState.pes_funcionario === 'S' ? 'N' : 'S',
                        }))
                      }}
                    />

                    <Form.Check
                      name="pes_parceiro"
                      label="Parceiro"
                      checked={customer.pes_parceiro === 'S' ? true : false}
                      onChange={() => {
                        setCustomer((prevState) => ({
                          ...prevState,
                          pes_parceiro:
                            prevState.pes_parceiro === 'S' ? 'N' : 'S',
                        }))
                      }}
                    />

                    <Form.Check
                      name="pes_prestador"
                      label="Prestador"
                      checked={customer.pes_prestador === 'S' ? true : false}
                      onChange={() => {
                        setCustomer((prevState) => ({
                          ...prevState,
                          pes_prestador:
                            prevState.pes_prestador === 'S' ? 'N' : 'S',
                        }))
                      }}
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Contribuinte</Form.Label>
                  <Form.Select
                    required
                    name="cod_tipo_contribuinte"
                    value={customer.cod_tipo_contribuinte || ''}
                    onChange={handleChange}
                  >
                    {tiposContribuinte.map((tipoContribuinte) => (
                      <option
                        key={tipoContribuinte.value}
                        value={tipoContribuinte.value}
                      >
                        {tipoContribuinte.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Tipo</Form.Label>
                  <Form.Select
                    required
                    name="pes_tipo"
                    value={customer.pes_tipo || ''}
                    onChange={handleChange}
                  >
                    {tiposPessoa.map((tipoPessoa) => (
                      <option
                        key={tipoPessoa.value}
                        value={tipoPessoa.value}
                      >
                        {tipoPessoa.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Cons. Final</Form.Label>
                  <Form.Select
                    required
                    name="pes_consumidor_final"
                    value={customer.pes_consumidor_final || ''}
                    onChange={handleChange}
                  >
                    <option value="SIM">Sim</option>
                    <option value="">Não</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Razão Social</Form.Label>
                  <Form.Control
                    required
                    name="pes_razao"
                    value={customer.pes_razao || ''}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Apelido</Form.Label>
                  <Form.Control
                    name="pes_fantasia"
                    value={customer.pes_fantasia || ''}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Data Fund.</Form.Label>
                  <Form.Control
                    type="date"
                    name="pes_data_fund_nasc"
                    value={
                      formatDate(customer.pes_data_fund_nasc, 'yyyy-MM-dd') ||
                      ''
                    }
                    onChange={(e) => console.log(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <div id="cnpj">
                  <Form.Group className="mb-3">
                    <div>
                      <Form.Label
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 10,
                        }}
                      >
                        {isJuridical ? 'CNPJ' : 'CPF'}

                        {isCNPJSearchLoading && <CustomSpinner size={15} />}
                      </Form.Label>
                    </div>

                    <ReactInputMask
                      required
                      mask={
                        isJuridical ? '99.999.999/9999-99' : '999.999.999-99'
                      }
                      value={customer.pes_cnpj_cpf || ''}
                      onChange={handleChange}
                      onBlur={isJuridical && getCompanyInfo}
                    >
                      {(inputProps) => (
                        <Form.Control
                          name="pes_cnpj_cpf"
                          {...inputProps}
                        />
                      )}
                    </ReactInputMask>
                  </Form.Group>
                </div>
              </Col>

              <Col className="mb-3">
                <Form.Group>
                  <Form.Label>Inscr. Estadual</Form.Label>
                  <Form.Control
                    name="pes_insc_estadual"
                    value={customer.pes_insc_estadual || ''}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Inscr. Municipal</Form.Label>
                  <Form.Control
                    name="pes_insc_municipal"
                    value={customer.pes_insc_municipal || ''}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <div>
                    <Form.Label
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                      }}
                    >
                      CEP
                      {isCEPSearchLoading && <CustomSpinner size={15} />}
                    </Form.Label>
                  </div>

                  <ReactInputMask
                    required
                    mask="99999-999"
                    value={customer.pes_cep || ''}
                    onChange={handleChange}
                    onBlur={getCEPInfo}
                  >
                    {(inputProps) => (
                      <Form.Control
                        name="pes_cep"
                        {...inputProps}
                      />
                    )}
                  </ReactInputMask>
                </Form.Group>
              </Col>

              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Logradouro</Form.Label>
                  <Form.Control
                    required
                    name="pes_logradouro"
                    value={customer.pes_logradouro || ''}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Nº</Form.Label>
                  <Form.Control
                    required
                    name="pes_numero"
                    value={customer.pes_numero || ''}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Complemento</Form.Label>
                  <Form.Control
                    name="pes_complemento"
                    value={customer.pes_complemento || ''}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Bairro</Form.Label>
                  <Form.Control
                    required
                    name="pes_bairro"
                    value={customer.pes_bairro || ''}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col xs={2}>
                <Form.Group className="mb-3">
                  <Form.Label>UF</Form.Label>
                  <Form.Control
                    required
                    name="pes_uf"
                    value={customer.pes_uf || ''}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Cidade</Form.Label>
                  <Form.Control
                    required
                    name="pes_cidade"
                    value={customer.pes_cidade || ''}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Telefone Fixo</Form.Label>
                  <ReactInputMask
                    mask="(99) 9999-9999"
                    value={customer.pes_telefone || ''}
                    onChange={handleChange}
                  >
                    {(inputProps) => (
                      <Form.Control
                        name="pes_telefone"
                        {...inputProps}
                      />
                    )}
                  </ReactInputMask>
                </Form.Group>
              </Col>

              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Celular</Form.Label>
                  <ReactInputMask
                    mask="(99) 99999-9999"
                    value={customer.pes_celular || ''}
                    onChange={handleChange}
                  >
                    {(inputProps) => (
                      <Form.Control
                        name="pes_celular"
                        {...inputProps}
                      />
                    )}
                  </ReactInputMask>
                </Form.Group>
              </Col>

              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Contato</Form.Label>

                  <ReactInputMask
                    mask="(99) 99999-9999"
                    value={customer.pes_contato || ''}
                    onChange={handleChange}
                  >
                    {(inputProps) => (
                      <Form.Control
                        name="pes_contato"
                        {...inputProps}
                      />
                    )}
                  </ReactInputMask>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Dados para Pagamento</Form.Label>
                  <Form.Control
                    name="pagamento"
                    value={customer.pagamento || ''}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>E-mail</Form.Label>
                  <Form.Control
                    name="pes_email"
                    value={customer.pes_email || ''}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>E-mail NF-e</Form.Label>
                  <Form.Control
                    name="pes_email_nfe"
                    value={customer.pes_email_nfe || ''}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div
              style={{
                display: 'flex',
              }}
            >
              <CustomButton
                color="#088c04"
                type="submit"
                title="Salvar"
                isLoading={isRequestLoading}
                isDisabled={isCEPSearchLoading || isCNPJSearchLoading}
              >
                <BsFloppyFill />
              </CustomButton>

              <CustomButton
                color=" #e81414 "
                title="Cancelar"
                onClick={onBack}
              >
                <XCircleFill />
              </CustomButton>
            </div>
          </Form>
        )}
      </>
    )
  },
)
